import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useCloseOnEscape } from '../reactHooks.js';
import Dialog from '../dialog/dialog.js';
import Input from '../input/input.js';
import { randomString } from '../../utils/web/webUtils.js';
import './alert.scss';
var myAlerts = {};

function Alert(props) {
  var {
    children,
    className,
    close,
    confirmBox = false,
    darkMode = false,
    header,
    height = null,
    width = null
  } = props;
  var [zIndex, setZIndex] = useState(1);
  useCloseOnEscape(close);
  useEffect(() => {
    var alertId = randomString();
    myAlerts[alertId] = {
      zIndex
    };
    return () => delete myAlerts[alertId];
  });

  var handleAlertZIndexClick = () => {
    var maxZIndex = Math.max(...Object.values(myAlerts).map(a => a.zIndex));
    setZIndex(maxZIndex + 1);
  };

  return /*#__PURE__*/React.createElement(Dialog, {
    className: classNames('alert', className),
    onMouseDown: handleAlertZIndexClick,
    style: {
      zIndex
    },
    close: close,
    darkMode: darkMode,
    header: header,
    height: height,
    width: width
  }, children, confirmBox ? /*#__PURE__*/React.createElement("div", {
    className: "confirmButtonsContainer"
  }, /*#__PURE__*/React.createElement(Input, {
    className: "okayButton",
    type: "button",
    label: "OK",
    onClick: close
  }), /*#__PURE__*/React.createElement(Input, {
    className: "cancelButton",
    type: "button",
    label: "Cancel",
    onClick: close
  })) : /*#__PURE__*/React.createElement("div", {
    className: "alertButtonsContainer"
  }, /*#__PURE__*/React.createElement(Input, {
    className: "okayButton",
    type: "button",
    label: "OK",
    onClick: close
  })));
}

export default Alert;